import { render, staticRenderFns } from "./VenueList.vue?vue&type=template&id=5411a844&scoped=true&"
import script from "./VenueList.vue?vue&type=script&lang=ts&"
export * from "./VenueList.vue?vue&type=script&lang=ts&"
import style0 from "./VenueList.vue?vue&type=style&index=0&id=5411a844&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5411a844",
  null
  
)

export default component.exports